import React from 'react';

function extractYouTubeVideoId(url: string): string | null {
	const regex =
		// Prettier adds the escape but eslint complains about it
		// eslint-disable-next-line no-useless-escape
		/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
	const match = url.match(regex);
	return match ? match[1] : null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MarkdownAnchor = (
	props: React.AnchorHTMLAttributes<HTMLAnchorElement>,
) => {
	const { children, href, title } = props;

	const videoId = href && extractYouTubeVideoId(href);
	if (videoId) {
		return (
			<iframe
				src={`https://www.youtube.com/embed/${videoId}`}
				title={title || 'YouTube embed'}
				width="100%"
				style={{ aspectRatio: '16/9' }}
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		);
	}

	return <a {...props}>{children}</a>;
};
